export enum ValidationPoints {
  CORRECT_VALIDATION = 25,
  BASE_PERCENTAGE = 0,
  INCORRECT_VALIDATION = 0,
  FIRST_LETTER = 10,
}
